import appModule from '../../app.module';

export default appModule.factory('serviceRoot', [
    '$location',
    'modalService',
    ServiceRoot
]);

function ServiceRoot($location, modalService) {
    return {
        getBaseUrl: getBaseUrl,
        errorStatusFilter: errorStatusFilter
    };

    function getBaseUrl() {
        var url = null;
        url = $location.protocol() + '://' + window.location.host + '/';
        return url;
    }

    var errorModal;
    function errorStatusFilter(response) {
        if (response.status == 500 && errorModal === undefined) {
            errorModal = modalService.openCustom({
                component: 'asError',
                size: 'md',
                resolve: {
                    reset: true
                }
            });
            errorModal.then(
                function() {
                    errorModal = undefined;
                },
                function() {
                    errorModal = undefined;
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// ./shared/services/serviceRoot.service.js